export default class Hero {
  constructor() {
    this.module = document.querySelector(".module")
    this.hero = document.querySelector(".hero")
    this.raceHero = document.querySelector(".race-hero")
    this.logo = document.querySelector(".hero__logo")
    this.logoSvg = this.logo ? this.logo.querySelector("svg") : null
    this.headerLogo = document.querySelector(".header:not(.header--small) .header__logo")

    this.video = this.hero
      ? this.hero.querySelector("video")
      : this.raceHero
        ? this.raceHero.querySelector("video")
        : null
    this.videoToggle = this.hero
      ? this.hero.querySelector(".play-pause")
      : this.raceHero
        ? this.raceHero.querySelector(".play-pause")
        : null
    this.videoToggleIcon = this.videoToggle
      ? this.videoToggle.querySelector(".play-pause__icon")
      : null
    this.videoToggleText = this.videoToggle
      ? this.videoToggle.querySelector(".play-pause__text")
      : null

    if (!this.module) {
      this.initAnimation()
    }

    this.initVideo()
  }

  initAnimation() {
    window.addEventListener("scroll", () => {
      this.setLogoStyles()
    })

    window.addEventListener("resize", () => {
      this.setLogoStyles()
    })

    document.addEventListener("DOMContentLoaded", () => {
      this.setLogoStyles()
    })
  }

  initVideo() {
    if (!this.video) return

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)")

    if (!mediaQuery.matches) {
      this.video.play()
      this.videoToggleIcon.classList.remove("play-pause__icon--play")
      this.videoToggleText.textContent = "Pause Video"
    }

    this.videoToggle.addEventListener("click", () => {
      if (this.video.paused) {
        this.video.play()
        this.videoToggleIcon.classList.remove("play-pause__icon--play")
        this.videoToggleIcon.classList.add("play-pause__icon--pause")
        this.videoToggleText.textContent = "Pause Video"
      } else {
        this.video.pause()
        this.videoToggleIcon.classList.remove("play-pause__icon--pause")
        this.videoToggleIcon.classList.add("play-pause__icon--play")
        this.videoToggleText.textContent = "Play Video"
      }
    })
  }

  setLogoStyles() {
    if (!this.hero) return

    const scrollY = window.scrollY
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    const logoSizeStart = this.logo.offsetWidth
    const logoSizeEnd = 167
    const logoLeftStart = 0
    const logoLeftEnd = -57

    if (windowWidth >= 1200) {
      const scrollPercent = Math.min(scrollY / (windowHeight / 2), 1)

      const scale = logoSizeStart - (logoSizeStart - logoSizeEnd) * scrollPercent
      const left = logoLeftStart - (logoLeftStart - logoLeftEnd) * scrollPercent

      this.logo.style.left = `${left}px`

      this.logoSvg.style.transform = `scale(${scale / logoSizeStart})`

      const logoTop = this.logo.getBoundingClientRect().top
      if (logoTop <= 20) {
        this.logoSvg.style.opacity = 0
        this.headerLogo.style.opacity = 1
        this.headerLogo.style.pointerEvents = "auto"
      } else {
        this.logoSvg.style.opacity = 1
        this.headerLogo.style.opacity = 0
        this.headerLogo.style.pointerEvents = "none"
      }
    } else {
      this.logoSvg.style.transform = "none"
      this.logo.style.left = "0"
    }
  }
}
